import { render } from "./Headquarters.vue?vue&type=template&id=d43f171a&scoped=true"
import script from "./Headquarters.vue?vue&type=script&lang=js"
export * from "./Headquarters.vue?vue&type=script&lang=js"

import "./Headquarters.vue?vue&type=style&index=0&id=d43f171a&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d43f171a"]])

export default __exports__